export default __webpack_public_path__ + "static/media/file-upload-icon.72878ff5.svg";